<template>
  <div class="create-document">
    <Header />
    <div uk-height-viewport>
      <div class="uk-flex uk-flex-center">
        <div>
          <br />

          <div uk-sticky class="uk-padding-small uk-background-muted uk-margin-remove">
            <progress id="progressbar" class="uk-progress" value="0" max="100"></progress>
            <div id="switch" uk-switcher="animation: uk-animation-fade; toggle: > *; active: 0;">
              <button
                class="uk-button uk-button-default uk-margin-right uk-border-rounded"
                type="button"
                v-on:click="toggleSwitchIndex(0)"
              >Devis</button>
              <button
                class="uk-button uk-button-default uk-margin-left uk-border-rounded"
                type="button"
                v-on:click="toggleSwitchIndex(1)"
              >Facture</button>
            </div>

            <ul class="uk-switcher uk-margin-small-top">
              <li>
                <legend class="uk-legend uk-text-bolder uk-text-center">Édition d'un devis</legend>
              </li>
              <li>
                <legend class="uk-legend uk-text-bolder uk-text-center">Édition d'une facture</legend>
              </li>
            </ul>
          </div>

          <div class="uk-card uk-card-default uk-padding uk-flex uk-flex-center uk-border-rounded">
            <form v-on:submit.prevent="createDocument">
              <fieldset class="uk-fieldset">
                <legend
                  class="uk-legend uk-text-bolder uk-text-left"
                >Informations personnelles du client</legend>

                <br />

                <div uk-grid>
                  <div class="uk-width-auto@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Civilité</label>
                    <select class="uk-select uk-border-rounded" v-model="form.gender.value">
                      <option value="male">Monsieur</option>
                      <option value="female">Madame</option>
                      <option value="copro">Copropriété</option>
                      <option value="company">Société</option>
                      <option value="agency">Agence</option>
                    </select>
                  </div>

                  <div class="uk-width-expand@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Nom</label>
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[form.lastName.hasError ? 'uk-form-danger' : '']"
                      type="text"
                      placeholder="Votre nom"
                      @blur="checkLastName()"
                      v-model="form.lastName.value"
                      autofocus
                      required
                    />
                    <label
                      class="uk-form-label uk-align-left uk-text-danger"
                    >{{form.lastName.errorMessage}}</label>
                  </div>

                  <div class="uk-width-expand@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Prénom</label>
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[form.firstName.hasError ? 'uk-form-danger' : '']"
                      type="text"
                      v-model="form.firstName.value"
                      @blur="checkFirstName()"
                      placeholder="Votre prénom"
                      required
                    />
                    <label
                      class="uk-form-label uk-align-left uk-text-danger"
                    >{{form.firstName.errorMessage}}</label>
                  </div>
                </div>

                <div uk-grid>
                  <div class="uk-width-1-2@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Téléphone</label>
                    <!-- <div class="uk-inline"> -->
                    <!-- <span class="uk-form-icon" uk-icon="icon: receiver"></span> -->
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[form.phoneNumber.hasError ? 'uk-form-danger' : '']"
                      type="tel"
                      placeholder="0X XX XX XX XX"
                      @blur="isPhoneNumber()"
                      v-model="form.phoneNumber.value"
                      pattern="0.*[0-9]{9}$"
                    />
                    <label
                      class="uk-form-label uk-align-left uk-text-danger"
                    >{{form.phoneNumber.errorMessage}}</label>
                    <!-- </div> -->
                  </div>

                  <div class="uk-width-expand@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Adresse e-mail</label>
                    <!-- <div class="uk-inline"> -->
                    <!-- <span class="uk-form-icon" uk-icon="icon: mail"></span> -->
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[form.email.hasError ? 'uk-form-danger' : '']"
                      type="email"
                      placeholder="votre.adresse@email.com"
                      @blur="isEmail()"
                      v-model="form.email.value"
                      pattern="[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$"
                      required
                    />
                    <label
                      class="uk-form-label uk-align-left uk-text-danger"
                    >{{form.email.errorMessage}}</label>
                  </div>
                  <!-- </div> -->
                </div>

                <br />
                <br />
                <hr />
                <br />

                <legend class="uk-legend uk-text-bolder uk-text-left">Localisation du bien</legend>

                <br />

                <div uk-grid>
                  <div class="uk-width-expand@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Adresse</label>
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[form.address.hasError ? 'uk-form-danger' : '']"
                      type="text"
                      v-model="form.address.value"
                      @blur="checkAddress()"
                      placeholder="Rue, Avenue, Chemin..."
                      required
                    />
                    <label
                      class="uk-form-label uk-align-left uk-text-danger"
                    >{{form.address.errorMessage}}</label>
                  </div>
                </div>

                <div uk-grid>
                  <div class="uk-width-auto@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Code postal</label>
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[form.zipCode.hasError ? 'uk-form-danger' : '']"
                      type="text"
                      v-model="form.zipCode.value"
                      placeholder="06250"
                      @blur="isZipCode()"
                      pattern="[0-9]{5}$"
                      required
                    />
                    <label
                      class="uk-form-label uk-align-left uk-text-danger"
                    >{{form.zipCode.errorMessage}}</label>
                  </div>

                  <div class="uk-width-expand@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Ville</label>
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[form.city.hasError ? 'uk-form-danger' : '']"
                      type="text"
                      v-model="form.city.value"
                      @blur="checkCity()"
                      placeholder="Mougins"
                      required
                    />
                    <label
                      class="uk-form-label uk-align-left uk-text-danger"
                    >{{form.city.errorMessage}}</label>
                  </div>

                  <div class="uk-width-expand@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Pays</label>
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[form.country.hasError ? 'uk-form-danger' : '']"
                      type="text"
                      v-model="form.country.value"
                      @blur="checkCountry()"
                      placeholder="France"
                      required
                    />
                    <label
                      class="uk-form-label uk-align-left uk-text-danger"
                    >{{form.country.errorMessage}}</label>
                  </div>
                </div>

                <br />
                <br />
                <hr />
                <br />

                <legend class="uk-legend uk-text-bolder uk-text-left">Prestations ajoutées</legend>

                <br />

                <div
                  uk-grid
                  v-for="(delivery, index) in selectedDeliveries"
                  :key="index"
                  class="uk-margin-remove-bottom uk-margin-remove-top"
                >
                  <div class="uk-width-2-5">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >{{getTypeLabelForDelivery(delivery)}}</label>
                    <input
                      class="uk-input uk-border-rounded"
                      type="text"
                      v-model="delivery.title"
                      :readonly="getReadOnlyStatusForDelivery(delivery)"
                      required
                    />
                  </div>

                  <div class="uk-width-1-6">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >{{getUnitLabelForDelivery(delivery)}}</label>
                    <div class="uk-inline uk-align-left uk-width-expand">
                      <span
                        class="uk-form-icon uk-form-icon-flip uk-margin-remove"
                      >{{getUnitForDelivery(delivery)}}</span>

                      <input
                        class="uk-input uk-border-rounded"
                        step=".01"
                        type="number"
                        :placeholder="getUnitLabelForDelivery(delivery)"
                        v-model="delivery.surface"
                        :min="getMinimumSurfaceForDelivery(delivery)"
                        required
                      />
                    </div>
                  </div>

                  <div class="uk-width-1-6">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Remise</label>
                    <div class="uk-inline uk-align-left uk-width-expand">
                      <span class="uk-form-icon uk-form-icon-flip uk-margin-remove">%</span>
                      <input
                        class="uk-input uk-border-rounded"
                        type="number"
                        placeholder="Remise (en %)"
                        v-model="delivery.discount"
                        :min="0"
                        :max="100"
                        required
                      />
                    </div>
                  </div>

                  <div class="uk-width-1-6">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Total TTC</label>
                    <div class="uk-inline uk-align-left uk-width-expand">
                      <span class="uk-form-icon uk-form-icon-flip uk-margin-remove">€</span>
                      <input
                        class="uk-input uk-border-rounded"
                        type="number"
                        :value="deliveryManager.getTotalPricing(delivery).toFixed(2)"
                        placeholder="Total TTC"
                        readonly
                      />
                    </div>
                  </div>

                  <div class="uk-width-auto uk-align-center">
                    <span
                      class="uk-icon-button uk-form-danger"
                      style="cursor:pointer"
                      uk-icon="icon: trash"
                      v-on:click="deleteDeliveryAt(index)"
                    ></span>
                  </div>
                </div>

                <div uk-grid class="uk-margin-remove-top" v-show="selectedDeliveries.length > 0">
                  <div class="uk-width-2-5"></div>
                  <div class="uk-width-1-3"></div>
                  <div class="uk-width-1-6">
                    <p
                      class="uk-text-bolder uk-text-right"
                    >TOTAL TTC : {{(deliveryManager.getTotalPricingForAllDeliveries(selectedDeliveries, form.freeTransport.value)).toFixed(2)}}€</p>
                  </div>
                  <div class="uk-width-auto uk-align-center">
                    <label>
                      <input v-model="form.freeTransport.value" class="uk-checkbox" type="checkbox" /> Offrir le transport
                    </label>
                  </div>
                </div>
                <div uk-grid class="uk-margin-remove-top" v-show="selectedDeliveries.length == 0">
                  <div class="uk-width-1-1">
                    <p class="uk-text-bolder uk-text-center">Aucune prestation ajoutée.</p>
                  </div>
                </div>

                <br />
                <br />
                <br />
                <br />

                <legend
                  class="uk-legend uk-text-bolder uk-text-left"
                >Quelle(s) prestation(s) souhaitez-vous ajouter ?</legend>
                <br />

                <div
                  uk-grid
                  class="uk-margin-remove-bottom uk-margin-remove-left uk-background-secondary uk-padding uk-border-rounded"
                >
                  <div class="uk-width-1-3">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Libellé</label>
                    <input
                      class="uk-input uk-border-rounded"
                      type="text"
                      v-model="customDelivery.title"
                    />
                  </div>

                  <div class="uk-width-1-6">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Prix TTC</label>
                    <div class="uk-inline uk-align-left uk-width-expand">
                      <span class="uk-form-icon uk-form-icon-flip uk-margin-remove">€</span>

                      <input
                        class="uk-input uk-border-rounded"
                        type="number"
                        placeholder="Prix TTC"
                        v-model="customDelivery.surface"
                        step=".01"
                        :min="0"
                      />
                    </div>
                  </div>

                  <div class="uk-width-1-6">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Remise</label>
                    <div class="uk-inline uk-align-left uk-width-expand">
                      <span class="uk-form-icon uk-form-icon-flip uk-margin-remove">%</span>
                      <input
                        class="uk-input uk-border-rounded"
                        type="number"
                        placeholder="Remise (en %)"
                        v-model="customDelivery.discount"
                        :min="0"
                        :max="100"
                      />
                    </div>
                  </div>

                  <div class="uk-width-1-6">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Total TTC</label>
                    <div class="uk-inline uk-align-left uk-width-expand">
                      <span class="uk-form-icon uk-form-icon-flip uk-margin-remove">€</span>
                      <input
                        class="uk-input uk-border-rounded"
                        type="number"
                        :value="customDelivery.surface - customDelivery.surface * (customDelivery.discount / 100)"
                        placeholder="Total TTC"
                        readonly
                      />
                    </div>
                  </div>

                  <div class="uk-width-auto uk-align-center">
                    <span
                      class="uk-icon-button uk-form-success"
                      style="cursor:pointer"
                      uk-icon="icon: plus;"
                      v-on:click="addCustomDelivery(customDelivery)"
                    ></span>
                  </div>
                </div>

                <div
                  uk-grid
                  class="uk-margin-remove-top uk-background-secondary uk-align-center uk-padding-small uk-border-rounded"
                >
                  <div class="uk-width-auto@m">
                    <div uk-form-custom="target: > * > span:first-child">
                      <select v-model="selectedDelivery" @change="addDelivery(selectedDelivery)">
                        <option>{{selectDeliveryTitle}}</option>
                        <option
                          v-bind:value="delivery"
                          v-for="(delivery, index) in dataDeliveries"
                          :key="index"
                          v-show="deliveryAlreadySelected(delivery)"
                        >{{delivery.title}}</option>
                      </select>
                      <button class="uk-button uk-button-default" type="button" tabindex="-1">
                        <span></span>
                        <span uk-icon="icon: chevron-down"></span>
                      </button>
                    </div>
                  </div>
                </div>

                <br />
                <br />
                <br />
                <br />

                <div
                  uk-grid
                  class="uk-margin uk-grid-small uk-child-width-auto uk-flex uk-flex-center uk-margin-remove-top"
                >
                  <div class="uk-width-auto@m uk-flex-center uk-border-rounded">
                    <div uk-form-custom="target: > * > span:first-child">
                      <select v-model="selectedCommunicationType" class="uk-border-rounded">
                        <option>{{selectCommunicationTitle}}</option>
                        <option
                          v-bind:value="communication"
                          v-for="(communication, index) in dataCommunicationTypes"
                          :key="index"
                        >{{communication.title}}</option>
                      </select>
                      <button class="uk-button uk-button-default" type="button" tabindex="-1">
                        <span></span>
                        <span uk-icon="icon: chevron-down"></span>
                      </button>
                    </div>
                  </div>
                </div>

                <div>
                  <div
                    v-show="selectedDeliveries.length > 0 && !isLoading && selectedCommunicationType != selectCommunicationTitle"
                    class="uk-margin uk-grid-small uk-child-width-auto uk-flex uk-flex-center"
                  >
                    <button
                      class="uk-button uk-button-primary uk-animation-scale-up uk-border-rounded uk-text-bold"
                    >GENERER MON DOCUMENT</button>
                  </div>
                  <div
                    v-show="selectedDeliveries.length > 0 && !isLoading && selectedCommunicationType != selectCommunicationTitle"
                    class="uk-margin uk-grid-small uk-child-width-auto uk-flex uk-flex-center"
                  ></div>
                </div>

                <br />
                <div
                  class="uk-margin uk-grid-small uk-child-width-auto uk-flex uk-flex-center"
                  uk-spinner
                  v-show="isLoading"
                ></div>

                <br />
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from "uikit";
import DeliveryType from "../enums/delivery-type";
import Quotation from "../models/quotation";
import CommunicationType from "../enums/communication-type";
import QuotationStatus from "../enums/quotation-status";
import FirestoreCollection from "../enums/firestore-collection";
import DeliveryManager from "../managers/delivery-manager";
import Header from "../components/Header";
import firebase from "firebase";
import router from "../router";

export default {
  name: "create-document",
  components: {
    Header
  },
  mounted() {
    const self = this;

    if (this.$route.params.collectionID) {
      self.collectionID = this.$route.params.collectionID.capitalize();
      if (
        self.collectionID === FirestoreCollection.QUOTATIONS ||
        self.collectionID === FirestoreCollection.INVOICES
      ) {
        const initialIndex =
          self.collectionID === FirestoreCollection.QUOTATIONS ? 0 : 1;
        UIkit.switcher("#switch").show(initialIndex);
      } else {
        return;
      }
      if (!this.$route.params.documentID) {
        return;
      }
    } else {
      self.collectionID = FirestoreCollection.QUOTATIONS;
      const initialIndex =
        self.collectionID === FirestoreCollection.QUOTATIONS ? 0 : 1;
      UIkit.switcher("#switch").show(initialIndex);
      return;
    }

    self.documentID = this.$route.params.documentID;

    firebase
      .firestore()
      .collection(self.collectionID)
      .doc(self.documentID)
      .get()
      .then(doc => {
        console.log(doc);
        if (doc.exists) {
          self.document = new Quotation(doc);
          self.form.address.value = self.document.address.address;
          self.form.city.value = self.document.address.city;
          self.form.zipCode.value = self.document.address.zipCode;
          self.form.country.value = self.document.address.country;
          self.form.firstName.value = self.document.firstName;
          self.form.lastName.value = self.document.lastName;
          self.form.freeTransport.value = self.document.freeTransport;
          self.form.gender.value = self.document.gender;
          self.form.email.value = self.document.email;
          self.form.phoneNumber.value = self.document.phoneNumber;
          self.document.deliveries.forEach(delivery => {
            delivery.discount = delivery.discount ? delivery.discount : 0;
            self.addDelivery(delivery);
          });
          this.toggleSwitchIndex(1);
          UIkit.switcher("#switch").show(1);
        } else {
          this.displayErrorMessage(
            "Aucun devis ne porte ce numéro d'identification."
          );
          return;
        }
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });
  },

  data() {
    return {
      deliveryManager: new DeliveryManager(),
      form: {
        firstName: { value: "", hasError: false },
        lastName: { value: "", hasError: false },
        gender: { value: "male", hasError: false },
        phoneNumber: { value: "", hasError: false },
        email: { value: "", hasError: false },
        address: { value: "", hasError: false },
        zipCode: { value: "", hasError: false },
        freeTransport: { value: false, hasError: false },
        city: { value: "", hasError: false },
        country: { value: "", hasError: false },
        progress: { value: 0 }
      },
      customDelivery: {
        type: DeliveryType.CUSTOM,
        title: "",
        surface: "",
        discount: 0
      },
      selectDeliveryTitle: "Ajouter une prestation prédéfinie",
      selectedDelivery: "Ajouter une prestation prédéfinie",
      dataDeliveries: [
        {
          type: DeliveryType.HOME,
          title: "Expertise avant achat d'une maison",
          surface: ""
        },
        {
          type: DeliveryType.APARTMENT,
          title: "Expertise avant achat d'un appartement",
          surface: ""
        },
        {
          type: DeliveryType.VEFA_HOME_BULKHEAD,
          title: "VEFA - Maison - Visite cloisons",
          surface: ""
        },
        {
          type: DeliveryType.VEFA_HOME_PRE_DELIVERY,
          title: "VEFA - Maison - Pré-livraison / Réserves (sans TMA)",
          surface: ""
        },
        {
          type: DeliveryType.VEFA_HOME_RECEPTION_DELIVERY,
          title: "VEFA - Maison - Réception / Livraison",
          surface: ""
        },
        {
          type: DeliveryType.VEFA_APARTMENT_BULKHEAD,
          title: "VEFA - Appartement - Visite cloisons",
          surface: ""
        },
        {
          type: DeliveryType.VEFA_APARTMENT_PRE_DELIVERY,
          title: "VEFA - Appartement - Pré-livraison / Réserves (sans TMA)",
          surface: ""
        },
        {
          type: DeliveryType.VEFA_APARTMENT_RECEPTION_DELIVERY,
          title: "VEFA - Appartement - Réception / Livraison",
          surface: ""
        },
        {
          type: DeliveryType.CCMI_FOUNDATION,
          title: "Visite fondation - CCMI",
          surface: ""
        },
        {
          type: DeliveryType.CCMI_BIG_WORK,
          title: "Visite gros œuvre - CCMI",
          surface: ""
        },
        {
          type: DeliveryType.CCMI_BULKHEAD,
          title: "Visite cloisons - CCMI",
          surface: ""
        },
        {
          type: DeliveryType.CCMI_COPE,
          title: "Visite chape - CCMI",
          surface: ""
        },
        {
          type: DeliveryType.CCMI_RECEPTION_DELIVERY,
          title: "Réception & Livraison - CCMI",
          surface: ""
        }
      ],
      selectCommunicationTitle: "Comment le client nous a-t-il connu ?",
      selectedCommunicationType: "Comment le client nous a-t-il connu ?",
      dataCommunicationTypes: [
        { type: CommunicationType.RADIO, title: "Radio" },
        { type: CommunicationType.TV, title: "TV" },
        { type: CommunicationType.PRESS, title: "Article de presse" },
        { type: CommunicationType.INTERNET, title: "Internet" },
        { type: CommunicationType.FRIEND, title: "Amis" },
        { type: CommunicationType.FACEBOOK, title: "Facebook" },
        { type: CommunicationType.LINKEDIN, title: "LinkedIn" },
        { type: CommunicationType.TWITTER, title: "Twitter" },
        { type: CommunicationType.AD_BOARD, title: "Panneau publicitaire" },
        { type: CommunicationType.OTHER, title: "Autre" }
      ],
      selectedDeliveries: [],
      isChecked: false,
      isLoading: false,
      userCanPay: false,
      documentID: "",
      collectionID: "",
      switchIndex: 0,
      document: { amount: 0 }
    };
  },
  methods: {
    toggleSwitchIndex(index) {
      this.switchIndex = index;
      this.collectionID =
        index == 0
          ? FirestoreCollection.QUOTATIONS
          : FirestoreCollection.INVOICES;
    },

    addCustomDelivery: function() {
      this.addDelivery(this.customDelivery);
      this.customDelivery = {
        type: DeliveryType.CUSTOM,
        title: "",
        surface: "0",
        discount: 0
      };
    },

    addDelivery: function(delivery) {
      if (delivery.title != this.selectDeliveryTitle) {
        this.selectedDeliveries.push(delivery);
        this.selectedDelivery = this.selectDeliveryTitle;
      }
      this.setProgress();
        UIkit.update();
    },

    deleteDeliveryAt: function(index) {
      this.selectedDeliveries.splice(index, 1);
      this.setProgress();
    },

    getMinimumSurfaceForDelivery(delivery) {
      return delivery.type == DeliveryType.GARDEN ||
        delivery.type == DeliveryType.WATERING ||
        delivery.type == DeliveryType.GARDEN
        ? 300
        : 1;
    },

    getUnitLabelForDelivery(delivery) {
      switch (delivery.type) {
        case DeliveryType.CUSTOM:
          return "Prix TTC";
        case DeliveryType.DELIVERY_ASSISTANCE_COMMON_PART:
          return "Nombre de lots";
        case DeliveryType.SWIMMING_POOL:
          return "Nombre de piscine";
        default:
          return "Surface";
      }
    },

    getUnitForDelivery(delivery) {
      switch (delivery.type) {
        case DeliveryType.CUSTOM:
          return "€";
        case DeliveryType.DELIVERY_ASSISTANCE_COMMON_PART:
          return "lots";
        case DeliveryType.SWIMMING_POOL:
          return "Pisc.";
        default:
          return "m²";
      }
    },

    getTypeLabelForDelivery(delivery) {
      return delivery.type === DeliveryType.CUSTOM ? "Libellé" : "Type";
    },

    getReadOnlyStatusForDelivery(delivery) {
      return delivery.type === DeliveryType.CUSTOM ? false : true;
    },

    isEmail: function() {
      console.log("Checking email validity");
      var regex = RegExp("[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$");
      this.form.email.value = this.form.email.value.trim();
      this.form.email.hasError = !regex.test(this.form.email.value);
      if (this.form.email.hasError) {
        this.form.email.errorMessage =
          "Votre adresse email n'est pas au bon format.";
      } else {
        this.form.email.errorMessage = "";
      }
      this.setProgress();
    },

    isPhoneNumber: function() {
      console.log("Checking phoneNumber validity");
      var regex = RegExp("0.*[0-9]{9}$");
      this.form.phoneNumber.value = this.form.phoneNumber.value.trim();
      this.form.phoneNumber.hasError = !regex.test(this.form.phoneNumber.value);
      if (this.form.phoneNumber.hasError) {
        this.form.phoneNumber.errorMessage =
          "Doit commencer par 0 et comporter 10 chiffres.";
      } else {
        this.form.phoneNumber.errorMessage = "";
      }
      this.setProgress();
    },

    isZipCode: function() {
      console.log("Checking zipCode validity");
      var regex = RegExp("[0-9]{5}$");
      this.form.zipCode.value = this.form.zipCode.value.trim();
      this.form.zipCode.hasError = !regex.test(this.form.zipCode.value);
      if (this.form.zipCode.hasError) {
        this.form.zipCode.errorMessage = "Doit comporter 5 chiffres.";
      } else {
        this.form.zipCode.errorMessage = "";
      }
      this.setProgress();
    },

    checkFirstName: function() {
      console.log("Checking firstname validity");
      var regex = RegExp("[a-zA-Z0-9._%+-]{2,}");
      this.form.firstName.value = this.form.firstName.value.trim();
      this.form.firstName.hasError = !regex.test(this.form.firstName.value);
      if (this.form.firstName.hasError) {
        this.form.firstName.errorMessage =
          "Doit contenir au moins deux caractères";
      } else {
        this.form.firstName.errorMessage = "";
      }
      this.setProgress();
    },

    checkLastName: function() {
      console.log("Checking lastname validity");
      var regex = RegExp("[a-zA-Z0-9._%+-]{2,}");
      this.form.lastName.value = this.form.lastName.value.trim();
      this.form.lastName.hasError = !regex.test(this.form.lastName.value);
      if (this.form.lastName.hasError) {
        this.form.lastName.errorMessage =
          "Doit contenir au moins deux caractères";
      } else {
        this.form.lastName.errorMessage = "";
      }
      this.setProgress();
    },

    checkAddress: function() {
      console.log("Checking address validity");
      var regex = RegExp("[a-zA-Z0-9._%+-]{2,}");
      this.form.address.value = this.form.address.value.trim();
      this.form.address.hasError = !regex.test(this.form.address.value);
      if (this.form.address.hasError) {
        this.form.address.errorMessage =
          "Doit contenir au moins deux caractères";
      } else {
        this.form.address.errorMessage = "";
      }
      this.setProgress();
    },

    checkCity: function() {
      console.log("Checking city validity");
      var regex = RegExp("[a-zA-Z0-9._%+-]{2,}");
      this.form.city.value = this.form.city.value.trim();
      this.form.city.hasError = !regex.test(this.form.city.value);
      if (this.form.city.hasError) {
        this.form.city.errorMessage = "Doit contenir au moins deux caractères";
      } else {
        this.form.city.errorMessage = "";
      }
      this.setProgress();
    },

    checkCountry: function() {
      console.log("Checking country validity");
      var regex = RegExp("[a-zA-Z0-9._%+-]{2,}");
      this.form.country.value = this.form.country.value.trim();
      this.form.country.hasError = !regex.test(this.form.country.value);
      if (this.form.country.hasError) {
        this.form.country.errorMessage =
          "Doit contenir au moins deux caractères";
      } else {
        this.form.country.errorMessage = "";
      }
      this.setProgress();
    },

    setProgress: function() {
      var progress = 0;
      progress +=
        this.form.firstName.value == "" || this.form.firstName.hasError
          ? 0
          : 10;
      progress +=
        this.form.lastName.value == "" || this.form.lastName.hasError ? 0 : 10;
      progress +=
        this.form.gender.value == "" || this.form.gender.hasError ? 0 : 10;
      progress +=
        this.form.phoneNumber.value == "" || this.form.phoneNumber.hasError
          ? 0
          : 10;
      progress +=
        this.form.email.value == "" || this.form.email.hasError ? 0 : 10;
      progress +=
        this.form.address.value == "" || this.form.address.hasError ? 0 : 10;
      progress +=
        this.form.zipCode.value == "" || this.form.zipCode.hasError ? 0 : 10;
      progress +=
        this.form.city.value == "" || this.form.city.hasError ? 0 : 10;
      progress +=
        this.form.country.value == "" || this.form.country.hasError ? 0 : 10;
      progress += this.selectedDeliveries.length == 0 ? 0 : 10;
      this.form.progress.value = progress;

      UIkit.util.ready(function() {
        var bar = document.getElementById("progressbar");
        bar.value = progress;
      });
    },

    deliveryAlreadySelected: function(delivery) {
      const types = this.selectedDeliveries.map(arg => {
        return arg.type;
      });
      return !types.includes(delivery.type);
    },

    createDocument: function() {
      if (
        confirm(
          "Vous confirmez vouloir créer " +
            this.getDocumentReadableType() +
            " ? Ce document sera envoyé à l'adresse " +
            this.form.email.value +
            "."
        )
      ) {
        this.isLoading = true;
        const data = {
          firstName: this.form.firstName.value,
          lastName: this.form.lastName.value,
          gender: this.form.gender.value,
          phoneNumber: this.form.phoneNumber.value,
          freeTransport: this.form.freeTransport.value,
          email: this.form.email.value,
          address: {
            address: this.form.address.value,
            zipCode: this.form.zipCode.value,
            city: this.form.city.value,
            country: this.form.country.value
          },
          deliveries: this.selectedDeliveries,
          communicationType: this.selectedCommunicationType,
          ownerUID: ""
        };

        if (
          this.collectionID === FirestoreCollection.QUOTATIONS &&
          this.$route.params.documentID === undefined
        ) {
          data.quotationID = makeQuotationID(8);
        } else {
          if (
            this.$route.params.collectionID !== undefined &&
            this.$route.params.collectionID.capitalize() ===
              FirestoreCollection.QUOTATIONS &&
            this.document instanceof Quotation
          ) {
            data.quotationID = this.document.quotationID;
            data.ownerUID = this.document.ownerUID;
            console.log(this.document);
          } else {
            data.quotationID = "";
          }
        }

        firebase
          .firestore()
          .collection(this.collectionID)
          .add(data)
          .then(() => {
            if (
              this.$route.params.collectionID !== undefined &&
              this.$route.params.collectionID.capitalize() ===
                FirestoreCollection.QUOTATIONS &&
              this.document instanceof Quotation
            ) {
              console.log("here");
              this.document.status = QuotationStatus.INVOICED;
              firebase
                .firestore()
                .collection(FirestoreCollection.QUOTATIONS)
                .doc(this.document.uid)
                .set(this.document.data, { merge: true })
                .then(() => {
                  this.isLoading = false;
                  router.push({ path: "/" });
                  this.displayMessage("Document créé avec succès.");
                })
                .catch(function(error) {
                  console.log("Error getting documents: ", error);
                });
            } else {
              this.isLoading = false;
              router.push({ path: "/" });
              this.displayMessage("Document créé avec succès.");
            }
          })
          .catch(function(error) {
            console.log("Error getting documents: ", error);
          });
      }
    },

    getDocumentReadableType() {
      return this.switchIndex === 0 ? "un devis" : "une facture";
    },

    displayMessage: function(message) {
      UIkit.notification("<span uk-icon='check: warning'></span> " + message, {
        pos: "top-right",
        status: "success"
      });
    }
  }
};

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

function makeQuotationID(length) {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
</script>

<style scoped>
.uk-background-secondary {
  background-color: #309fb520;
}
</style>
